import { APP_URL } from "./index";
import { EsProxyClient } from "@vegan-friendly/es-proxy-client";


const getEsProxyBaseURL = () =>
  process.env.REACT_APP_ELASTIC_SEARCH_QUERY_URL || APP_URL + "elasticsearch";

const esProxyClient = new EsProxyClient(getEsProxyBaseURL());

export default esProxyClient;
